// Closet.jsx
// お気に入りクローゼット（D案・2026-09-24）。撮影した服の一覧と、データ活用への同意（任意・既定OFF）。
// 写真・AI判定・お手入れ履歴は RFDB が持ち、API（/closet/*.php）が中継する。API が enabled:0 の環境では案内だけ出す。
import { IoChevronBack, IoAdd } from "react-icons/io5";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { TailSpin } from 'react-loading-icons';
import { Analytics } from '../compornents/Analytics';
import { ITEM_ICON_PATHS } from '../compornents/closetImage';

// アプリ標準の見出しバー（クーポン・その他などと同じ toolbar）
export const ClosetToolbar = ({ title, onBack }) => (
  <div className="toolbar mb-3">
    <div className="toolbar_left div_btn" onClick={onBack}>
      {onBack && <IoChevronBack />}
    </div>
    <div className="toolbar_center">{title}</div>
    <div className="toolbar_right"></div>
  </div>
);

// 画面いっぱいの黄色ボタン（button-next は Register 以外では幅が決まっていないので明示する）
export const FULL_BTN = { width: '100%', maxWidth: 'none' };

export const ItemIcon = ({ itemKey, size = 34 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" strokeLinecap="round">
    {itemKey === 'other' && <circle cx="12" cy="12" r="8.5" />}
    {(ITEM_ICON_PATHS[itemKey] || ITEM_ICON_PATHS.other).map((d) => <path key={d} d={d} />)}
  </svg>
);

// 品目の選択（AIの判定を直す・判定できなかったときに選ぶ）
export const ItemPicker = ({ itemKeys, value, onChange }) => (
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))', gap: 8 }}>
    {itemKeys.map((k) => {
      const on = k.key === value;
      return (
        <button key={k.key} type="button" onClick={() => onChange(k.key)}
          style={{
            border: `1.5px solid ${on ? '#15803d' : '#ddd'}`, background: on ? '#f2fbf4' : '#fff', borderRadius: 10,
            padding: '8px 4px', fontSize: 12, fontWeight: on ? 700 : 500, color: '#16201a', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
          }}>
          <span style={{ color: on ? '#15803d' : '#5a6166' }}><ItemIcon itemKey={k.key} size={26} /></span>
          {k.label}
        </button>
      );
    })}
  </div>
);

const Toggle = ({ checked, onChange }) => (
  <label style={{ position: 'relative', display: 'inline-block', width: 46, height: 26, margin: 0, flex: '0 0 auto' }}>
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} style={{ opacity: 0, width: 0, height: 0 }} />
    <span style={{ position: 'absolute', cursor: 'pointer', inset: 0, borderRadius: 26, background: checked ? '#ffd60a' : '#ccc', transition: '.2s' }}>
      <span style={{ position: 'absolute', height: 20, width: 20, left: checked ? 23 : 3, bottom: 3, background: '#fff', borderRadius: '50%', transition: '.2s', boxShadow: '0 1px 2px rgba(0,0,0,.3)' }} />
    </span>
  </label>
);

export const ConsentCard = ({ agreed, onChange, busy }) => (
  <div style={{ border: '1px solid #ddd', borderRadius: 12, padding: 14, background: '#fff' }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
      <div style={{ fontWeight: 700, fontSize: 14 }}>衣類データの活用に協力する（任意）</div>
      {busy ? <TailSpin stroke="#000" width={26} height={26} /> : <Toggle checked={agreed} onChange={onChange} />}
    </div>
    <div style={{ fontSize: 12, color: '#666', lineHeight: 1.7, marginTop: 6 }}>
      撮影した服の写真と判定結果を、お客様個人がわからない形に加工したうえで、衣類の統計・相場情報の作成や判定精度の改善に使わせていただきます。
      オフのままでもクローゼットはご利用いただけます。いつでも変更できます。
    </div>
  </div>
);

export const Closet = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const r = await Post('post', '/closet/index.php', {});
    if (r && r.result === 1) setData(r);
    else setData({ enabled: 0 });
  };
  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 10);
    load();
  }, []);

  const setConsent = async (agree) => {
    setBusy(true);
    const r = await Post('post', '/closet/consent.php', { agree: agree ? 1 : 0 });
    setBusy(false);
    if (r && r.result === 1) {
      toast.success(agree ? 'ご協力ありがとうございます' : '衣類データの活用をオフにしました');
      load();
    } else {
      toast.error((r && r.error_message) || '変更できませんでした');
    }
  };

  const enabled = data && Number(data.enabled) === 1;
  const items = (data && data.items) || [];

  return (
    <div className="App">
      <div className="Address">
        <Analytics title="お気に入りクローゼット" />
        <ClosetToolbar title="お気に入りクローゼット" onBack={() => navigate('/account')} />
        <div className="m-4 mb-5 text-left">
          {!data ? <TailSpin stroke="#000" /> : !enabled ? (
            <div style={{ fontSize: 14 }}>お気に入りクローゼットは準備中です。</div>
          ) : (
            <>
              <p style={{ fontSize: 14, lineHeight: 1.7, marginBottom: 12 }}>
                よく出す服を撮影しておくと、AIが品目を判定して、ここに並びます。
                次回からは一覧から選ぶだけでご注文いただけます。
              </p>
              <button className="button-next" onClick={() => navigate('/closet/add')} style={{ ...FULL_BTN, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                <IoAdd /> 服を撮影して追加
              </button>

              <div style={{ fontWeight: 700, fontSize: 14, margin: '18px 0 8px' }}>撮影した服（{items.length}点）</div>
              {items.length === 0 ? (
                <div style={{ fontSize: 13, color: '#666', padding: '16px 0' }}>まだ登録された服はありません。</div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                  {items.map((it) => (
                    <div key={it.id} className="div_btn" onClick={() => navigate(`/closet/${it.id}`)}
                      style={{ border: '1px solid #ddd', borderRadius: 12, padding: 10, background: '#fff' }}>
                      <div style={{ width: '100%', height: 110, borderRadius: 8, background: '#f3f4f3', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#5a6166' }}>
                        {it.thumb_url ? <img src={it.thumb_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <ItemIcon itemKey={it.item_key || 'other'} />}
                      </div>
                      <div style={{ fontSize: 13, fontWeight: 700, marginTop: 6 }}>{it.item_label || '品目を選んでください'}</div>
                      {it.item_name && <div style={{ fontSize: 11, color: '#5a6166', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.item_name}</div>}
                    </div>
                  ))}
                </div>
              )}

              <div style={{ marginTop: 22 }}>
                <ConsentCard agreed={Number(data.consent?.agreed) === 1} onChange={setConsent} busy={busy} />
                <div className="div_btn" onClick={() => navigate('/privacy')} style={{ fontSize: 12, color: '#1d4ed8', marginTop: 8 }}>プライバシーポリシーを見る</div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
